import { useEffect, useState } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import LoanWizard from "./LoanWizard";

export default function LoanWizardLauncher() {
  const [open, setOpen] = useState(false);
  const [defaultLoanType, setDefaultLoanType] = useState("Personal Loan");

  useEffect(() => {
    const h = (e) => {
      if (e?.detail?.loan_type) setDefaultLoanType(e.detail.loan_type);
      setOpen(true);
    };
    window.addEventListener("tara:open-wizard", h);
    return () => window.removeEventListener("tara:open-wizard", h);
  }, []);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-2xl p-0 overflow-hidden bg-white" data-testid="loan-wizard-dialog">
        <LoanWizard onDone={() => setOpen(false)} defaultLoanType={defaultLoanType} />
      </DialogContent>
    </Dialog>
  );
}
